// extracted by mini-css-extract-plugin
export default {"projectsContainer":"Account_projectsContainer__S8vvc"};